import styled, { css } from "styled-components";
import Col from "../kit/Column";
import Row from "../kit/Row";

export const globalFlexCenter = css`
  justify-content: center;
  align-items: center;
`;
export const globalFlexStart = css`
  justify-content: flex-start;
  align-items: flex-start;
`;

export const IconContainer = styled(Row)`
  cursor: pointer;
  width: ${(props) => props.size || "15px"};
  height: ${(props) => props.size || "15px"};
  svg {
    width: ${(props) => props.size || "15px"};
    height: ${(props) => props.size || "15px"};
  }
`;
export const ActionIconsContainer = styled(Row)``;

export const ActionIconsItem = styled(IconContainer)`
  margin: 0 5px;
`;

export const TableWrapper = styled(Col)`
width: 100%;
table {
    border-collapse:separate; 
    border-spacing: 0 1em;
  }
table td{
    font-family: ${(props) => (props.theme.fontDefault)};
    color: ${(props) => props.theme.text};
    border:none;
    background-color : #f1f2f3;
}
table th{
    font-family: ${(props) => (props.theme.fontDefault)};
    color: ${(props) => props.theme.secondaryFontColor};
    border:none;
    background-color : #e0e6ed;
}
tr td:first-child , tr th:first-child{
    border-top-right-radius: ${(props) => props.lang === "fa" ? "10px" : "0"};
    border-bottom-right-radius: ${(props) => props.lang === "fa" ? "10px" : "0"};
    border-top-left-radius: ${(props) => props.lang === "en" ? "10px" : "0"}; 
    border-bottom-left-radius: ${(props) => props.lang === "en" ? "10px" : "0"};
   }
tr td:last-child , tr th:last-child { 
    border-top-left-radius: ${(props) => props.lang === "fa" ? "10px" : "0"};
    border-bottom-left-radius: ${(props) => props.lang === "fa" ? "10px" : "0"};
    border-top-right-radius: ${(props) => props.lang === "en" ? "10px" : "0"};
    border-bottom-right-radius: ${(props) => props.lang === "en" ? "10px" : "0"};  
}

button{
    height: 100%;
    background-color: ${(props) => props.theme.white};
    border-radius: ${(props) => props.theme.borderRadius};
    border: 1px solid ${(props) => props.theme.secondaryFontColor};;
    width: 100%;
    color : ${(props) => props.theme.secondaryFontColor};
    cursor :pointer;
    font-family: ${(props) => (props.theme.fontDefault)};
 }
 #actions_container{
    height:38px;
    display :flex;
    align-items:center;
    justify-content:center;
 }
 #comment_icon{
     padding: 0 3px;
     margin: 0 3px;
     display :flex;
     height: 100%;
     justify-content: center;
     align-items: center;
      background-color: ${(props) => props.theme.thirdFontColor};
      border-radius: ${(props) => props.theme.borderRadius};
     svg{width :25px; height:20px;}
 }


`;


